import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

export default {
  markMessagesRead: async ({ commit, state }, data) => {
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      setTimeout(() => {
        if (state.markedUnReadStatus[id]) {
          commit(mutationTypes.CLEAR_MARKED_UNREAD_STATUS, { id });
        } else {
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        }
      }, 4000);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      commit(mutationTypes.SET_MARKED_UNREAD_STATUS, { id });
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  clearMarkUnreadStatus: ({ commit }, { id }) => {
    commit(mutationTypes.CLEAR_MARKED_UNREAD_STATUS, { id });
  },
};
